<template>
  <section class="pricing">
    <h2 test-id="long_grass_pricing-pricing">{{ t('pricing') }}</h2>
    <LsInfoCard>
      <h4 test-id="long_grass_pricing-pricing_works_title">
        {{ t('longGrass.longGrassReport.howLongGrassPricingWorks.title') }}
      </h4>

      <p test-id="long_grass_pricing-pricing_works_description">
        {{ t('longGrass.longGrassReport.howLongGrassPricingWorks.description') }}
      </p>

      <p>
        <RouterLink
          :to="{ name: 'longGrassPricing' }"
          class="learn-more-pricing"
          test-id="long_grass_pricing-learn_more_pricing_link"
        >
          {{ t('longGrass.longGrassReport.howLongGrassPricingWorks.learnMore') }}
        </RouterLink>
      </p>
    </LsInfoCard>
    <dl class="breakdown">
      <dd>
        <span>{{ mowingCycle }}</span>
        <span test-id="long_grass_pricing-original_price">{{ originalPrice | currency }}</span>
      </dd>
      <dd>
        <span>
          <span test-id="long_grass_pricing-label_main">{{ labelMain }}</span> <br />
          <span test-id="long_grass_pricing-label_details">{{ labelDetails }}</span>
        </span>
        <span test-id="long_grass_pricing-long_grass_price">{{ lgPrice | currency }}</span>
      </dd>
      <dd>
        <span class="trust-safety-fee">
          <span>{{ t('trust_and_safety_fee.title') }}</span>
          <BTooltip
            class="tooltip"
            :label="t('trust_and_safety_fee.tooltip', { brandName })"
            position="is-top"
            test-id="long_grass_pricing-trust_fee_tip"
            multilined
            >?
          </BTooltip>
        </span>
        <span test-id="long_grass_pricing-trust_fee">{{ trustFee | currency }}</span>
      </dd>
      <dd v-if="shouldDisplayTaxes">
        <span test-id="long_grass_pricing-taxes_label">{{ t('taxes') }}</span>
        <span test-id="long_grass_pricing-taxes">{{ tax | currency }}</span>
      </dd>
      <dt>
        <span test-id="long_grass_pricing-total_label">{{ t('total') }}</span>
        <span test-id="long_grass_pricing-total">{{ total | currency }}</span>
      </dt>
    </dl>
    <div v-if="withFootNotes" class="is-italic" test-id="long_grass_pricing-foot_notes">
      <span>{{ t('pricingNotReflectCreditsOrPromos') }}</span>
    </div>
  </section>
</template>

<script>
import { themedComponentMixin } from '@/mixins';
import VueTypes from 'vue-types';
import LsInfoCard from '@/components/common/LsInfoCard/LsInfoCard.vue';

export default {
  name: 'LgPricingSection',
  components: { LsInfoCard },
  mixins: [themedComponentMixin],
  props: {
    mowingCycle: VueTypes.string.required,
    longGrassLabel: VueTypes.string.required,
    originalPrice: VueTypes.number.required,
    lgPrice: VueTypes.number.required,
    trustFee: VueTypes.number.required,
    tax: VueTypes.number.required,
    total: VueTypes.number.required,
    withFootNotes: VueTypes.bool.required,
  },
  computed: {
    labelMain() {
      return this.longGrassLabel ? this.longGrassLabel.split(' (')[0] : '';
    },
    labelDetails() {
      return this.longGrassLabel ? ` (${this.longGrassLabel.split(' (')[1]}` : '';
    },
    shouldDisplayTaxes() {
      return this.tax > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.pricing {
  padding: 3rem 0;
  border-top: 1px solid $theme-color-primary-light;

  h2 {
    margin: 0 0 2rem;
  }
  .info-card {
    flex-direction: column;
    padding: 2rem 4.5rem;
    h4 {
      font-weight: 700;
      text-transform: uppercase;
      margin-bottom: 0.5rem;
    }
    p,
    h4 {
      text-align: left;
      width: 100%;
    }
    .learn-more-pricing {
      margin-top: 0.5rem;
      text-decoration: underline;
    }
  }
  dl {
    margin-top: 2rem;
    margin-bottom: 1rem;
    dt,
    dd {
      padding: 1rem;
      display: flex;
      justify-content: space-between;
    }
    dd {
      & ~ dd {
        border-top: 1px solid $theme-color-primary-light;
      }
      & > span {
        display: inline-block;
        & ~ span {
          margin-left: 5rem;
        }
        & > span {
          & ~ span {
            white-space: nowrap;
          }
        }
      }
    }
    dt {
      line-height: 1;
      font-weight: 700;
      background: $theme-color-primary-light;
    }
  }
  .trust-safety-fee {
    align-items: center;
    display: inline-flex;
    .tooltip {
      margin-left: 10px;
      color: $theme-color-white;
      height: 22px;
      width: 22px;
      background: $blue;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      cursor: pointer;
    }
  }
  .bottom-note {
    margin-top: 1rem;
  }
}
</style>
